import { render, staticRenderFns } from "./select-course.vue?vue&type=template&id=cdb87d2a&scoped=true&"
import script from "./select-course.vue?vue&type=script&lang=js&"
export * from "./select-course.vue?vue&type=script&lang=js&"
import style0 from "./select-course.vue?vue&type=style&index=0&id=cdb87d2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb87d2a",
  null
  
)

export default component.exports